<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Card payment</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (cart) {
    <ion-grid class="large-inputs" style="width: 400px;">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <ion-list>
            <ion-item lines="full">
              <ion-label>Amount due</ion-label>
              {{cart.currency.sign}}{{cart.amount_due | number:'1.2'}}
            </ion-item>
            <ion-item lines="full">
              <ion-input type="tel" class="ion-text-right" inputmode="decimal" maxlength="10" label="Payment amount" [(ngModel)]="payment_amount" (ngModelChange)="sanitisePaymentAmount()"></ion-input>
            </ion-item>
            @if (payment.price > 0) {
              @if (surcharge_rate && surcharge_rate > 0) {
                <ion-item lines="full">
                  <ion-toggle (ionChange)="toggleSurcharge()" label-placement="start" [(ngModel)]="surcharge_enabled">Apply {{surcharge_rate}}% surcharge</ion-toggle>
                </ion-item>
              }
              @if (surcharge_enabled && surcharge_rate && surcharge_rate > 0) {
                <ion-item lines="full">
                  <ion-label>Payment surcharge</ion-label>
                  {{cart.currency.sign}}{{surcharge_price | number:'1.2'}}
                </ion-item>
              }
              <ion-item lines="full">
                <ion-label>Amount to charge</ion-label>
                {{cart.currency.sign}}{{payment.price | number:'1.2'}}
              </ion-item>
              <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="addPayment()">
                <ion-label>ADD PAYMENT</ion-label>
              </ion-item>
            }
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>